{
    "GenericAdminFilterLanguage_CME_LABEL": "CME",
    "GenericAdminFilterLanguage_TELSYS_LABEL": "Telefonieserver",
    "GenericAdminFilterLanguage_PARTITION_LABEL": "Partition",
    "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "CRM-Typ",
    "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Untergeordnete CME-Elemente einschließen",
    "GenericAdminFilterLanguage_SEARCH_LABEL": "Suchen",
    "NAME": "GenericAdminFilterLanguage"
}